import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { toast } from "sonner";
import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const LoginPage = ({ setAuth }) => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const [showPassword, setShowPassword] = useState(false);
  const navigate = useNavigate();

  const handleLogin = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
      const response = await axios.post(`${API}/auth/login`, { email, password });
      localStorage.setItem('token', response.data.token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
      setAuth(true);
      toast.success('Login berhasil!');
      navigate('/portal');
    } catch (error) {
      toast.error(error.response?.data?.detail || 'Login gagal. Periksa email dan password Anda.');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <link rel="stylesheet" href="/login-assets/css/bootstrap.min.css" />
      <link rel="stylesheet" href="/login-assets/css/style.css" />
      <style>{`
        .toggle-password { cursor: pointer; }
        .login-error {
          margin-bottom: 16px;
          padding: 10px;
          border-radius: 6px;
          background: #ffe5e5;
          color: #a40000;
          text-align: center;
        }
      `}</style>

      <div className="js-fullheight" style={{ minHeight: '100vh' }}>
        <section className="ftco-section img" style={{ 
          minHeight: '100vh',
          backgroundImage: 'url(/login-assets/images/ocs.png)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
          backgroundRepeat: 'no-repeat'
        }}>
          <div className="container">
            <div className="row justify-content-center">
              <div className="col-md-6 col-lg-4">
                <div className="login-wrap">
                  <div className="mb-4 text-center brand">
                    <img src="/login-assets/images/bluee.png" alt="Blue Bill" style={{ maxWidth: '180px' }} />
                  </div>

                  <form onSubmit={handleLogin} className="signin-form" autoComplete="off" noValidate>
                    <div className="form-group">
                      <input
                        type="email"
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                        autoComplete="email"
                        required
                      />
                    </div>
                    <div className="form-group" style={{ position: 'relative' }}>
                      <input
                        id="password-field"
                        type={showPassword ? "text" : "password"}
                        className="form-control"
                        placeholder="Password"
                        value={password}
                        onChange={(e) => setPassword(e.target.value)}
                        autoComplete="current-password"
                        required
                      />
                      <span
                        className={`fa fa-fw ${showPassword ? 'fa-eye-slash' : 'fa-eye'} field-icon toggle-password`}
                        onClick={() => setShowPassword(!showPassword)}
                      />
                    </div>
                    <div className="form-group">
                      <button
                        type="submit"
                        disabled={loading}
                        className="form-control btn btn-primary submit px-3"
                      >
                        {loading ? 'Loading...' : 'LOG IN'}
                      </button>
                    </div>
                  </form>
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>

      <script src="/login-assets/js/jquery.min.js" />
      <script src="/login-assets/js/popper.js" />
      <script src="/login-assets/js/bootstrap.min.js" />
      <script src="/login-assets/js/main.js" />
    </>
  );
};

export default LoginPage;